<div *ngIf="sale" id="htmlData">
    <div class="card">
        <div class="row">
            <div class="col-md-4  d-flex justify-content-center">
                <div class="p-2 pt-4">
                    <h5>LM estudio creativo</h5>
                    <h6>CUIT: 20-39032119-9</h6>
                </div>
            </div>
            <div class="col-md-4  d-flex justify-content-center">
                <div class="logo-lm p-2 d-flex justify-content-center">
                    <img src="../../../../../assets/img/LOGO_LM.svg" alt="">
                </div>
            </div>
            <div class="col-md-4 d-flex justify-content-center">
                <div class="p-2 pt-4">
                    <h5>Cliente: <b>{{sale.cliente}}</b></h5>
                    <h6>Fecha: {{sale.fecha | date: 'dd/MM/yyyy'}}</h6>
                </div>
            </div>
        </div>
    </div>
    <div class="card mt-3">
        <table class="table table-hover table-md-responsive table-sm-responsive mb-3">
            <thead class="">
                <tr class="">
                    <th>Fecha</th>
                    <th>Pedido</th>
                    <th>Descripción</th>
                    <th>Monto</th>
                    <th>Saldo</th>
                </tr>
            </thead>
            <tbody *ngIf="sale">
                <tr>
                    <td scope="row">{{sale.fecha | date: 'dd/MM/YY'}}</td>
                    <td>{{sale.pedido}}</td>
                    <td>{{sale.descripcion}}</td>
                    <td><strong>${{sale.monto}}</strong></td>
                    <td><strong>${{sale.saldo}}</strong></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<a mat-raised-button color="accent" class="mt-3" (click)="download()"><mat-icon>download</mat-icon> Descargar PDF</a>